import { type FallbackRender, ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import React, {
  type FunctionComponent,
  type ReactNode,
  Suspense,
  lazy,
  useCallback
} from 'react';

import { dynamicImport } from '@canvas/dynamic-import';

const DatabaseFatalError = lazy(() =>
  dynamicImport(() => import('./DatabaseFatalError'))
);

const ErrorBoundary: FunctionComponent<{
  children: ReactNode;
}> = ({ children }) => {
  const fallback: FallbackRender = useCallback(
    ({ error }) => (
      <Suspense>
        <DatabaseFatalError error={error} />
      </Suspense>
    ),
    []
  );

  return (
    <SentryErrorBoundary
      beforeCapture={(scope) => {
        scope.setLevel('fatal');
      }}
      fallback={fallback}
    >
      {children}
    </SentryErrorBoundary>
  );
};

export default ErrorBoundary;
